import React from 'react';
import config from '../config';

const _generateDownloadLink = () => {
  const token = config.getPlainAuthToken();
  return config.apiUrl + '/excel-export?authToken=' + token;
};

export default () => <a href={_generateDownloadLink()}>Excel Download</a>;



// WEBPACK FOOTER //
// ./src/components/ExcelDownload.js